import React, {Component} from 'react';
import {Api} from '../../api';
import {checkAuth, getAuthToken} from '../../utils';
import {connect} from 'react-redux';
import './TransactionSelectCompany.scss';
import SelectInput from "../../components/Common/SelectInput";
import ButtonInput from "../../components/Common/ButtonInput";

function Li(props) {
    return <button onClick={props.handleClick}>{props.name}</button>
}

class TransactionSelectCompany extends Component {

    state = {
        isLoading: true,
        transactionData: {},
        userCertificates: [],
        userCertificateIndex: -1,
        userCompanyIndex: -1,
        searchResult: [],
        secondUserEmail: '',
        secondUserTaxNumber: '',
        paymentDescription: '',
        isEmailSelected: false,
        isNextEnable: false,
        selectedFiles: [],
    };

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
    }

    componentWillMount() {
        this.props.handleLoader(true);
    }

    componentDidMount() {
        const authToken = getAuthToken();
        const transactionData = JSON.parse(localStorage.getItem('proof-transaction'));
        if (!transactionData) {
            this.props.history.push('/user/transactions/proof');
        }

        Api.get('certificates/current', authToken).then((response) => {
            this.setState({userCertificates: response.data, transactionData: transactionData, isLoading: false});
            this.props.handleLoader(false);
        }).catch((error) => {
            console.log('error', error);
            checkAuth(error.response, this.props.history);
        });
    }

    updateUserCertificate(event) {
        this.setState({userCertificateIndex: event.target.value, userCompanyIndex: -1});
    }

    updateUserCompany(event) {
        this.setState({userCompanyIndex: event.target.value});
    }

    searchSecondUser(event) {
        const authToken = getAuthToken();
        Api.get('user/emails?email=' + event.target.value, authToken).then(response => {
            this.setState({searchResult: response.data});
        }).catch((error) => {
            console.log('error', error);
            checkAuth(error.response, this.props.history);
        });
    }

    onInputCompany(event) {
        console.log(event.target.name);
        console.log(event.target.value);
        this.setState({secondUserTaxNumber: event.target.value});
    }

    onSelectEmail = (event) => {
        const elementId = event.target.id;
        const index = elementId.substring('searched-email-'.length);
        const secondUserEmail = this.state.searchResult[index];
        this.setState({secondUserEmail: secondUserEmail, searchResult: [], isEmailSelected: true});
    };

    cancelEmail = (event) => {
        this.setState({secondUserEmail: '', isEmailSelected: false});
    };

    onChangePaymentDescription = (event) => {
        this.setState({paymentDescription: event.target.value})
    };

    onNext = (event) => {
        if (!this.state.secondUserTaxNumber || this.state.secondUserTaxNumber === '') {
            if (this.state.transactionData.userStatus === 'Sender') {
                alert('Please enter recipient company code');
            } else {
                alert('Please enter sender company code');
            }
        }

        const secondUserEmail = this.state.secondUserEmail;
        const secondUserCompanyCode = this.state.secondUserTaxNumber;
        const userCertificate = this.state.userCertificates[this.state.userCertificateIndex];
        const userCompany = userCertificate.companies[this.state.userCompanyIndex];
        const transactionData = this.state.transactionData;
        transactionData.paymentDescription = this.state.paymentDescription;
        transactionData.attachedFiles = this.state.selectedFiles;
        if (this.state.transactionData.userStatus === 'Sender') {
            transactionData.recipientEmail = secondUserEmail;
            transactionData.recipientTaxNumber = secondUserCompanyCode;
            transactionData.senderCertificate = userCertificate;
            transactionData.senderCompany = userCompany;
        } else if (this.state.transactionData.userStatus === 'Recipient') {
            transactionData.senderEmail = secondUserEmail;
            transactionData.senderTaxNumber = secondUserCompanyCode;
            transactionData.recipientCertificate = userCertificate;
            transactionData.recipientCompany = userCompany;
        }

        localStorage.removeItem('proof-transaction');
        console.log('Final result');
        const result = JSON.stringify(transactionData);
        console.log(result);
        localStorage.setItem('select-company-transaction', JSON.stringify(transactionData));
        this.props.history.push('/user/transaction/transactionPage');
    };

    onSelectFiles = (event) => {
        this.setState({selectedFiles:[]});
        for (const file of Array.from(event.target.files)) {
            console.log(file);
            this.getBase64(file, (result) => {
                const fileData = {
                    data: result,
                    name: file.name,
                };
                const selectedFiles = this.state.selectedFiles;
                selectedFiles.push(fileData);
            });
        }
    };


    getBase64 = (file, cb) => {
        let reader = new FileReader();
        reader.onload = function () {
            const index = reader.result.indexOf(",");
            if (index !== -1) {
                cb(reader.result.substring(index + 1, reader.result.length));
            } else {
                cb(reader.result)
            }
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
        reader.readAsDataURL(file);
    };

    render() {
        const {isLoading, transactionData, userCertificates, userCertificateIndex, userCompanyIndex, searchResult, isEmailSelected, secondUserEmail, isNextEnable} = this.state;
        return (
            <div>
                {!isLoading ?
                    <div>
                        <div className='content-wrapper'>
                            <div className="content">
                                <div className="content-h2">Declare transaction</div>
                                <div className="hr-content"/>

                                <div className="content-h2">Sender</div>
                                {transactionData.userStatus === 'Sender' ?
                                    <div className="fields-row">
                                        <SelectInput name='senderCertificate'
                                                     id='senderCertificate'
                                                     label='Signature'
                                                     required={true}
                                                     isValue={true}
                                                     value={userCertificateIndex}
                                                     classes='width-328'
                                                     displayedField={'name'}
                                                     options={userCertificates}
                                                     handleChange={(e) => this.updateUserCertificate(e)}/>
                                        <SelectInput name='senderCompany'
                                                     id='senderCompany'
                                                     label='Company'
                                                     required={true}
                                                     isValue={true}
                                                     value={userCompanyIndex}
                                                     classes='width-328'
                                                     displayedField={'entity'}
                                                     options={userCertificateIndex === -1 ? [] : userCertificates[userCertificateIndex].companies}
                                                     handleChange={(e) => this.updateUserCompany(e)}/>
                                    </div>
                                    :
                                    <div style={{marginBottom: '16px'}}>
                                        <div className="row" id="search-block">
                                            <div className="col-lg-8">
                                                <label className="field-hint-label">Sender email</label>
                                            </div>
                                            <div className="col-lg-8">
                                                {!isEmailSelected ?
                                                    <input type="text" className="form-control" placeholder="Search"
                                                           onChange={(e) => this.searchSecondUser(e)}/>
                                                    :
                                                    <div className="btn-group">
                                                        <input type="text" className="form-control"
                                                               value={secondUserEmail}
                                                               disabled={true}/>
                                                        <span className="close-icon" onClick={this.cancelEmail}></span>
                                                    </div>
                                                }
                                            </div>
                                            <div className="col-lg-8" id="search-result-block">
                                                <ul className="list-group on-top full-width">
                                                    {searchResult.map((email, index) => {
                                                        return (
                                                            <li className="list-group-item list-group-item-action"
                                                                id={'searched-email-' + index}
                                                                onClick={this.onSelectEmail}>
                                                                {email}
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="row" id="search-block">
                                            <div className="col-lg-8">
                                                <label className="field-hint-label">Sender company id</label>
                                            </div>
                                            <div className="col-lg-8">
                                                <input type="text" className="form-control"
                                                       placeholder="Enter company ID"
                                                       onChange={(e) => this.onInputCompany(e)}/>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col-lg-6">
                                        <table className="table io-table">
                                            <thead>
                                            <tr>
                                                <th scope="col">Amount</th>
                                                <th scope="col">Wallet address</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {transactionData.senderData.map((senderData, index) => {
                                                return (
                                                    <tr>
                                                        <td className={0 === index ? 'first-row' : ''}>
                                                            {Number((senderData.value / 100000000).toFixed(4))}
                                                        </td>
                                                        <td className={0 === index ? 'first-row' : ''}>
                                                            {senderData.address}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="content-h2">Recipient</div>
                                {transactionData.userStatus === 'Sender' ?
                                    <div style={{marginBottom: '16px'}}>
                                        <div className="row">
                                            <div className="col-lg-8">
                                                <label className="field-hint-label">Recipient email</label>
                                            </div>
                                            <div className="col-lg-8">
                                                {!isEmailSelected ?
                                                    <input type="text" className="form-control" placeholder="Search"
                                                           onChange={(e) => this.searchSecondUser(e)}/>
                                                    :
                                                    <div className="btn-group">
                                                        <input type="text" className="form-control"
                                                               value={secondUserEmail}
                                                               disabled={true}/>
                                                        <span className="close-icon" onClick={this.cancelEmail}></span>
                                                    </div>
                                                }
                                            </div>
                                            <div className="col-lg-8" id="search-result-block">
                                                <ul className="list-group on-top full-width">
                                                    {searchResult.map((email, index) => {
                                                        return (
                                                            <li className="list-group-item list-group-item-action"
                                                                id={'searched-email-' + index}
                                                                onClick={this.onSelectEmail}>
                                                                {email}
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-8">
                                                <label className="field-hint-label">Recipient company id</label>
                                            </div>
                                            <div className="col-lg-8">
                                                <input type="text" className="form-control"
                                                       placeholder="Enter company ID"
                                                       onChange={(e) => this.onInputCompany(e)}/>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="fields-row">
                                        <SelectInput name='senderCertificate'
                                                     id='senderCertificate'
                                                     label='Signature'
                                                     required={true}
                                                     isValue={true}
                                                     value={userCertificateIndex}
                                                     classes='width-328'
                                                     displayedField={'name'}
                                                     options={userCertificates}
                                                     handleChange={(e) => this.updateUserCertificate(e)}/>
                                        <SelectInput name='senderCompany'
                                                     id='senderCompany'
                                                     label='Company'
                                                     required={true}
                                                     isValue={true}
                                                     value={userCompanyIndex}
                                                     classes='width-328'
                                                     displayedField={'entity'}
                                                     options={userCertificateIndex === -1 ? [] : userCertificates[userCertificateIndex].companies}
                                                     handleChange={(e) => this.updateUserCompany(e)}/>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col-lg-6">
                                        <table className="table io-table">
                                            <thead>
                                            <tr>
                                                <th scope="col">Amount</th>
                                                <th scope="col">Wallet address</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {transactionData.recipientData.map((recipientData, index) => {
                                                return (
                                                    <tr>
                                                        <td className={0 === index ? 'first-row' : ''}>
                                                            {Number((recipientData.value / 100000000).toFixed(4))}
                                                        </td>
                                                        <td className={0 === index ? 'first-row' : ''}>
                                                            {recipientData.address}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3">
                                        <div className="amount-block">
                                            <label>Total amount: <i
                                                className="user-status">{Math.abs(Number((transactionData.totalAmount / 100000000).toFixed(4)))} {transactionData.currency}</i></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3 tx-desc-label">
                                        <label>Transaction description</label>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-8">
                                        <input className="form-control" type="text" placeholder="Contract payment"
                                               aria-label="Search" className="payment-descr-input"
                                               onChange={this.onChangePaymentDescription}/>
                                    </div>
                                </div>

                                <div className="row margin-top-25">
                                    <div className="col-lg-2 tx-desc-label">
                                        <label>Attache files</label>
                                    </div>
                                    <div className="col-lg-3 tx-desc-label">
                                        <input type="file" name="file" accept=".pdf,.png,.jpg,.gif,.jpeg" onChange={this.onSelectFiles} multiple/>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="offset-lg-10 col-lg-2">
                                        {secondUserEmail !== '' && this.state.userCertificateIndex !== -1 && this.state.userCompanyIndex !== -1 ?
                                            <ButtonInput
                                                id="next-button"
                                                className={`dark-button black-btn`}
                                                title='Next'
                                                handleClick={(e) => this.onNext(e)}/> : <div></div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<TransactionHistory/>*/}
                    </div> : <div></div>
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(TransactionSelectCompany);


// WEBPACK FOOTER //
// ./src/views/TransactionSelectCompany/TransactionSelectCompany.js